class WelcomeOfferBuilder extends HTMLElement {
  constructor() {
    super();

    this._selectedItems = [];
    this._filters = [];
    this.maxBundleSize = parseInt(this.getAttribute('max-bundle-size')) || 2;

    this.cards = null;
    this.originalOrder = null;
    this.productsContainer = null;
    this.footer = null;
    this.filterBtns = null;

    this.addItem = this.addItem.bind(this);
    this.removeItem = this.removeItem.bind(this);
    this.onFilterClick = this.onFilterClick.bind(this);
  }

  set selectedItems(items) {
    this._selectedItems = items;
    this._onSelectionChange();
  }
  get selectedItems() {
    return this._selectedItems;
  }

  connectedCallback() {
    this.productsContainer = this.querySelector('.welcome-offer-builder__products');
    this.cards = Array.from(this.productsContainer.querySelectorAll('welcome-offer-product-card'));
    this.originalOrder = [...this.cards];
    this.footer = this.querySelector('welcome-offer-builder-footer');

    this.addEventListener('welcome-offer-add-item', (e) => this.addItem(e.detail));
    this.addEventListener('welcome-offer-remove-item', (e) => this.removeItem(e.detail));

    this.filterBtns = Array.from(this.querySelectorAll('.welcome-offer-builder__filters--tag'));
    this.filterBtns.forEach((btn) => btn.addEventListener('click', this.onFilterClick));

    this._applyFilters();
  }

  disconnectedCallback() {
    this.filterBtns?.forEach((btn) => btn.removeEventListener('click', this.onFilterClick));
  }

  addItem({ productId, variantId, productTitle, productColor, productImage }) {
    const totalQty = this._selectedItems.reduce((sum, i) => sum + i.quantity, 0);
    if (totalQty >= this.maxBundleSize) return;

    const items = [...this._selectedItems];
    const idx = items.findIndex((i) => i.variantId === variantId);
    if (idx > -1) items[idx].quantity += 1;
    else
      items.push({ productId, variantId, productTitle, productColor, productImage, quantity: 1 });

    this.selectedItems = items;
  }

  removeItem({ variantId }) {
    const items = [...this._selectedItems];
    const idx = items.findIndex((i) => i.variantId === variantId);
    if (idx === -1) return;
    items[idx].quantity -= 1;
    if (items[idx].quantity === 0) items.splice(idx, 1);

    this.selectedItems = items;
  }

  onFilterClick(event) {
    const btn = event.currentTarget;
    const filter = btn.dataset.filter;
    const pressed = btn.getAttribute('aria-pressed') === 'true';

    if (pressed) {
      this._filters = this._filters.filter((f) => f !== filter);
      btn.setAttribute('aria-pressed', 'false');
    } else {
      this._filters.push(filter);
      btn.setAttribute('aria-pressed', 'true');
    }

    this._applyFilters();
  }

  _applyFilters() {
    const hasFilters = this._filters.length > 0;

    if (hasFilters) {
      const matched = [];
      const unmatched = [];

      this.originalOrder.forEach((card) => {
        const tags = (card.dataset.tags || '').split(',').map((t) => t.trim());
        const matches = this._filters.some((f) => tags.includes(f));

        card.style.opacity = matches ? '1' : '0.3';
        if (matches) matched.push(card);
        else unmatched.push(card);
      });

      const sorted = matched.concat(unmatched);
      sorted.forEach((card) => this.productsContainer.appendChild(card));
      this.cards = sorted;
    } else {
      this.originalOrder.forEach((card) => {
        card.style.opacity = '1';
        this.productsContainer.appendChild(card);
      });
      this.cards = [...this.originalOrder];
    }
  }

  _onSelectionChange() {
    const totalQty = this._selectedItems.reduce((sum, i) => sum + i.quantity, 0);
    this.cards.forEach((card) => {
      const match = this._selectedItems.find((i) => i.variantId === card.variantId);
      card.updateProperties({ quantity: match?.quantity || 0, bundleSize: totalQty });
    });

    this.footer?.updateProperties({ selectedItems: this._selectedItems });
  }
}

customElements.define('welcome-offer-builder', WelcomeOfferBuilder);
